import "core-js/modules/es.function.name";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/esm/createClass";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * Utilities related to the use of Browser storage features.
 * @export
 * @class BrowserStorageUtils
 */

var BrowserStorageUtils = /*#__PURE__*/function () {
  function BrowserStorageUtils() {
    _classCallCheck(this, BrowserStorageUtils);
  }

  _createClass(BrowserStorageUtils, null, [{
    key: "checkStorageAvailable",

    /* istanbul ignore next */

    /**
     * Check if the browser supports the use of storage.
     *
     * @param {*} type of storage, can be 'localStorage' or 'sessionStorage'
     */
    value: function checkStorageAvailable(type) {
      var storage;

      try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      } catch (error) {
        return error instanceof DOMException && ( // everything except Firefox
        error.code === 22 || // Firefox
        error.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        error.name === 'QuotaExceededError' || // Firefox
        error.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage.length !== 0;
      }
    }
    /**
     * Check if the browser supports the use of cookies.
     */

  }, {
    key: "checkCookiesAvailable",
    value: function checkCookiesAvailable() {
      var _context; // Quick test if browser has cookieEnabled host property


      var available = window.navigator.cookieEnabled; // Create cookie

      window.document.cookie = 'test=cookie';
      available = available && _indexOfInstanceProperty(_context = window.document.cookie).call(_context, 'test=') !== -1; // Delete cookie

      window.document.cookie = 'test=cookie; expires=Thu, 01-Jan-1970 00:00:01 GMT';
      return available;
    }
  }]);

  return BrowserStorageUtils;
}();
/**
 * Utilities related to the use of local storage features.
 * @export
 * @class localStorage
 */


export { BrowserStorageUtils as default };
export var localStorage = /*#__PURE__*/function () {
  function localStorage() {
    _classCallCheck(this, localStorage);
  }

  _createClass(localStorage, null, [{
    key: "key",

    /**
     * When passed a number n, this method will return the name of the nth key in the storage.
     */
    value: function key(index) {
      try {
        return window.localStorage.key(index);
      } catch (error) {
        return null;
      }
    }
    /**
     * When passed a key name, will return that key's value.
     */

  }, {
    key: "getItem",
    value: function getItem(keyName) {
      try {
        return window.localStorage.getItem(keyName);
      } catch (error) {
        return null;
      }
    }
    /**
     * When passed a key name and value, will add that key to the storage, or update that key's value if it already exists.
     */

  }, {
    key: "setItem",
    value: function setItem(keyName, keyValue) {
      try {
        return window.localStorage.setItem(keyName, keyValue);
      } catch (error) {
        return null;
      }
    }
    /**
     * When passed a key name, will remove that key from the storage.
     */

  }, {
    key: "removeItem",
    value: function removeItem(keyName) {
      try {
        return window.localStorage.removeItem(keyName);
      } catch (error) {
        return null;
      }
    }
    /**
     * When invoked, will empty all keys out of the storage.
     */

  }, {
    key: "clear",
    value: function clear() {
      try {
        return window.localStorage.clear();
      } catch (error) {
        return null;
      }
    }
    /**
     * When invoked, will remove all items in the local storage that are expired and meet the passed criteria
     */

  }, {
    key: "removeExpiredItems",
    value: function removeExpiredItems(criteriaFunction) {
      var _context2, _context3;

      var now = new Date();

      _forEachInstanceProperty(_context2 = _filterInstanceProperty(_context3 = _Object$keys(window.localStorage)).call(_context3, criteriaFunction)).call(_context2, function (key) {
        var item = window.localStorage.getItem(key);

        var _JSON$parse = JSON.parse(item),
            expiry = _JSON$parse.expiry;

        if (now.getTime() > expiry) {
          window.localStorage.removeItem(key);
        }
      });
    }
  }]);

  return localStorage;
}();
/**
 * Utilities related to the use of session storage features.
 * @export
 * @class sessionStorage
 */

export var sessionStorage = /*#__PURE__*/function () {
  function sessionStorage() {
    _classCallCheck(this, sessionStorage);
  }

  _createClass(sessionStorage, null, [{
    key: "key",

    /**
     * When passed a number n, this method will return the name of the nth key in the storage.
     */
    value: function key(index) {
      try {
        return window.sessionStorage.key(index);
      } catch (error) {
        return null;
      }
    }
    /**
     * When passed a key name, will return that key's value.
     */

  }, {
    key: "getItem",
    value: function getItem(keyName) {
      try {
        return window.sessionStorage.getItem(keyName);
      } catch (error) {
        return null;
      }
    }
    /**
     * When passed a key name and value, will add that key to the storage, or update that key's value if it already exists.
     */

  }, {
    key: "setItem",
    value: function setItem(keyName, keyValue) {
      try {
        return window.sessionStorage.setItem(keyName, keyValue);
      } catch (error) {
        return null;
      }
    }
    /**
     * When passed a key name, will remove that key from the storage.
     */

  }, {
    key: "removeItem",
    value: function removeItem(keyName) {
      try {
        return window.sessionStorage.removeItem(keyName);
      } catch (error) {
        return null;
      }
    }
    /**
     * When invoked, will empty all keys out of the storage.
     */

  }, {
    key: "clear",
    value: function clear() {
      try {
        return window.sessionStorage.clear();
      } catch (error) {
        return null;
      }
    }
  }]);

  return sessionStorage;
}();